import * as React from 'react';
import { Box, FormControl, IconButton, InputBase, InputLabel, MenuItem, Paper, Popover, Select, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { InsertLink, BookmarkBorder } from '@mui/icons-material';
import AddLinkIcon from '@mui/icons-material/AddLink';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';

const IB = styled(IconButton)(({ theme }) => ({
    borderRadius: 0,
}));

export default function TextLinkPopover(props) {
    const { setElemento, selectItem } = props;
    const [link, setLink] = React.useState('');
    const [bookMark, setBookMark] = React.useState('');
    const [listId, setListId] = React.useState([]);
    const [bookMarkSelect, setBookMarkSelect] = React.useState('');
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [anchorElBookMark, setAnchorElBookMark] = React.useState(null);
    const [savedSelection, setSavedSelection] = React.useState(null);

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const openBookMark = Boolean(anchorElBookMark);
    const idBookMark = openBookMark ? 'simple-popover' : undefined;


    React.useEffect(() => {


        if (selectItem) {
            let elementoComId = selectItem;

            if (selectItem.nodeType === Node.TEXT_NODE) {
                elementoComId = selectItem.parentElement;
            }

            if (!elementoComId.id && elementoComId.parentElement) {
                const paiComId = elementoComId.closest('[id]');
                if (paiComId) {
                    elementoComId = paiComId;
                }
            }

            if (elementoComId.id != "very2Editor") {
                setBookMark(elementoComId.id);
            } else {
                setBookMark('');
            }
            if (selectItem.tagName === 'A') {
                const href = selectItem.getAttribute('href');
                setLink(href);
            } else {
                setLink('');
            }

        } else {
            setLink('');
            setBookMark('');
        }
    }, [selectItem]);

    const handleLinkTxt = (event) => {
        const selecao = window.getSelection();
        if (selecao.rangeCount > 0) {
            const range = selecao.getRangeAt(0).cloneRange();
            setSavedSelection(range);
        } else {
            setSavedSelection(null);
        }
        const editor = document.querySelector('#very2Editor');
        if (!editor) {
            return [];
        }

        const elementosComId = editor.querySelectorAll('[id]');
        const ids = [];

        elementosComId.forEach(elemento => {
            if (elemento.id === 'very2Editor') return;
            if (elemento.id && elemento.id.trim() !== '' && !/^\d+$/.test(elemento.id)) {
                ids.push({
                    id: elemento.id,
                    tag: elemento.tagName,
                    texto: elemento.textContent?.substring(0, 50) || '(sem texto)',
                    elemento: elemento
                });
            }
        });

        setListId(ids);
        setAnchorEl(event.currentTarget);
    };

    const handleLBookMark = (event) => {
        const selecao = window.getSelection();
        if (selecao.rangeCount > 0) {
            const range = selecao.getRangeAt(0).cloneRange();
            setSavedSelection(range);
        } else {
            setSavedSelection(null);
        }
        setAnchorElBookMark(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleCloseBookMark = () => {
        setAnchorElBookMark(null);
    };
    const handleChangeLink = (e) => {
        setLink(e.target.value)
    };

    const handleChangeBookMark = (e) => {
        setBookMark(e.target.value)
    };

    const handleAdicionarBookMark = (e) => {

        const descId = bookMark.trim();
        if (!descId) {
            console.warn('Por favor, insira um BookMark');
            return;
        }

        let rangeParaUsar = null;

        if (savedSelection) {
            rangeParaUsar = savedSelection;
        } else {
            const selecao = window.getSelection();
            if (selecao.rangeCount > 0) {
                rangeParaUsar = selecao.getRangeAt(0);
            }
        }

        if (!rangeParaUsar) {
            console.warn('Nenhuma seleção disponível');
            alert('Por favor, selecione um texto primeiro');
            return;
        }

        const textoSelecionado = rangeParaUsar.toString().trim();
        if (!textoSelecionado) {
            console.warn('Texto selecionado está vazio');
            return;
        }

        const bookmarkElement = document.createElement('span');
        bookmarkElement.id = descId; // O ID que servirá como âncora
        bookmarkElement.textContent = textoSelecionado;

        rangeParaUsar.deleteContents();
        rangeParaUsar.insertNode(bookmarkElement);

        setSavedSelection(null);
        setBookMark(''); // Limpa o input
        handleCloseBookMark();
    };


    const handleAdicionarLink = (e) => {

        const url = link.trim();
        if (!url) {
            console.warn('Por favor, insira uma URL');
            return;
        }

        let rangeParaUsar = null;

        if (savedSelection) {
            rangeParaUsar = savedSelection;
        } else {
            const selecao = window.getSelection();
            if (selecao.rangeCount > 0) {
                rangeParaUsar = selecao.getRangeAt(0);
            }
        }

        if (!rangeParaUsar) {
            console.warn('Nenhuma seleção disponível');
            alert('Por favor, selecione um texto primeiro');
            return;
        }

        const textoSelecionado = rangeParaUsar.toString().trim();
        if (!textoSelecionado) {
            console.warn('Texto selecionado está vazio');
            return;
        }

        // Cria o link
        const linkElement = document.createElement('a');
        linkElement.href = url;
        linkElement.textContent = textoSelecionado;
        const ehLinkInterno = url.startsWith('#');

        if (ehLinkInterno) {
            linkElement.removeAttribute('target');
            linkElement.removeAttribute('rel');
            linkElement.classList.add('link-interno');
        } else {
            // linkElement.target = '_blank';
            linkElement.rel = 'noopener noreferrer';
            //linkElement.classList.add('link-externo');
        }
        rangeParaUsar.deleteContents();
        rangeParaUsar.insertNode(linkElement);

        setSavedSelection(null);
        handleClose();
    };

    const handleChangeBookMarkSelect = (e) => {
        setBookMarkSelect(e.target.value)
        setLink(e.target.value)
        handleAdicionarLink(e);
    };

    return (
        <React.Fragment>
            <Tooltip title="Link">
                <IB
                    // color="primary" 
                    onClick={handleLinkTxt}
                    size="small"
                    color={selectItem?.tagName === 'A' ? 'primary' : 'secundary'}
                >
                    <InsertLink />
                </IB>
            </Tooltip>
            <Tooltip title="BookMark">
                <IB
                    // color="primary" 
                    onClick={handleLBookMark}
                    size="small"
                    color={bookMark ? 'primary' : 'secundary'}
                >
                    <BookmarkBorder />
                </IB>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ p: 2, width: 380 }}>
                    <Paper
                        component="form"
                        sx={{
                            p: '6px 8px',
                            display: 'flex',
                            alignItems: 'center',
                            // mb: 1.5,
                            borderRadius: 1
                        }}
                    >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="Link"
                            inputProps={{ 'aria-label': 'Link' }}
                            value={link}
                            onChange={handleChangeLink}
                        />
                        <IconButton
                            type="button"
                            sx={{ p: '10px' }}
                            aria-label="search"
                            onClick={handleAdicionarLink}
                        >
                            <AddLinkIcon />
                        </IconButton>
                    </Paper>
                    <FormControl
                        fullWidth
                        sx={{ mb: 1, mt: 1 }}
                    >
                        <InputLabel id="demo-simple-select-label">BookMark</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={bookMarkSelect}
                            label="BookMark"
                            onChange={handleChangeBookMarkSelect}
                        >
                            {listId.map((item, index) => (
                                <MenuItem
                                    key={`${item.id}_item_${index}`}
                                    value={`#${item.id}`}
                                >{item.id}</MenuItem>
                            ))}
                            {/* <MenuItem value={10}>Ten</MenuItem>
                            <MenuItem value={20}>Twenty</MenuItem>
                            <MenuItem value={30}>Thirty</MenuItem> */}
                        </Select>
                    </FormControl>
                </Box>
            </Popover>
            <Popover
                id={idBookMark}
                open={openBookMark}
                anchorEl={anchorElBookMark}
                onClose={handleCloseBookMark}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            >
                <Box sx={{ p: 2, width: 380 }}>
                    <Paper
                        component="form"
                        sx={{
                            p: '6px 8px',
                            display: 'flex',
                            alignItems: 'center',
                            // mb: 1.5,
                            borderRadius: 1
                        }}
                    >
                        <InputBase
                            sx={{ ml: 1, flex: 1 }}
                            placeholder="BookMark"
                            inputProps={{ 'aria-label': 'BookMark' }}
                            value={bookMark}
                            onChange={handleChangeBookMark}
                        />
                        <IconButton
                            type="button"
                            sx={{ p: '10px' }}
                            aria-label="search"
                            onClick={handleAdicionarBookMark}
                        >
                            <BookmarkAddIcon />
                        </IconButton>
                    </Paper>
                </Box>
            </Popover>
        </React.Fragment>
    )
}